import React from "react";
import {Box, useMediaQuery} from "@material-ui/core";

function Block(props) {
    const matches = useMediaQuery('(max-width:600px)');

    return (
        <>
            <Box display={"flex"} width={"100%"} justifyContent={"center"} alignItems={"center"}
                 flexDirection={"column"} margin={"50px 0"}>
                <Box width={!matches ? props.blockWidth : "unset"} textAlign={"center"} color={"var(--text-color)"}>
                    <h2>{props.title}</h2>
                    <p style={{display: props.desc === "disabled" && "none", whiteSpace: "pre-line", textAlign: props.textAlign}}>{props.desc}</p>
                    {props.children}
                </Box>
            </Box>
        </>
    )
}

export default Block